import _ from "lodash";

export const createDocumentContent = ({ text, entry }) => {
  if (entry && entry.type === "reset") {
    return "";
  }
  if (entry && _.includes(["insert", "paste"], entry.type)) {
    const index = entry.ibi - 1;
    return _.join([text.slice(0, index), entry.s, text.slice(index)], "");
  }
  if (entry && entry.type === "delete") {
    const start = entry.si - 1;
    const end = entry.ei;
    return _.join([text.slice(0, start), text.slice(end)], "");
  }
  return text;
};

export const getDocumentParts = ({ text, entry }) => {
  if (entry && _.includes(["insert", "paste"], entry.type)) {
    const i = entry.ibi - 1;
    return [
      { text: text.slice(0, i) },
      { text: entry.s, type: entry.type },
      { text: text.slice(i) },
    ];
  }
  if (entry && entry.type === "delete") {
    const start = entry.si - 1;
    const end = entry.ei;
    return [
      { text: text.slice(0, start) },
      { text: text.slice(start, end), type: "delete" },
      { text: text.slice(end) },
    ];
  }
  if (entry && entry.type === "reset") {
    return [{ text: text, type: "delete" }];
  }
  return [{ text }];
};

export const getPlaybackSpeedOptions = ({ t }) => [
  {
    key: "PLAYBACK_SPEED_OPTIONS",
    label: t("classRoom:playback_speed"),
    isItemGroup: true,
    options: [
      {
        key: "1",
        label: "1x",
      },
      {
        key: "2",
        label: "2x",
      },
      {
        key: "5",
        label: "5x",
      },
      {
        key: "10",
        label: "10x",
      },
      {
        key: "50",
        label: "50x",
      },
      {
        key: "100",
        label: "100x",
      },
    ],
  },
];
